var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 0H2.75A2.752 2.752 0 000 2.75v13.5A2.752 2.752 0 002.75 19H4v4.25a.75.75 0 001.28.53L10.06 19h11.19A2.752 2.752 0 0024 16.25V2.75A2.752 2.752 0 0021.25 0zm-7.21 13.891A1.116 1.116 0 0112.92 15h-1.84a1.154 1.154 0 01-1.12-1.29v-.54h4.08zm.81-2.96a2.146 2.146 0 00-.78 1.24H9.94a1.881 1.881 0 00-.73-1.19 4.42 4.42 0 01-1.71-3.6A4.523 4.523 0 0111.93 3a4.465 4.465 0 012.92 7.93z",
    fill: "#5f48e9"
  })));
}

export default SvgTipIcon;